// src/__internal__/activity/makeStepId.ts
import { id } from "@stackflow/core";
function makeStepId() {
  return id();
}
export {
  makeStepId
};
